/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Synthflow Backend
 * OpenAPI spec version: 1.0
 */

export type ActionTypeParameter =
  (typeof ActionTypeParameter)[keyof typeof ActionTypeParameter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionTypeParameter = {
  ivr: "ivr",
  sms: "sms",
  transfer: "transfer",
  booking: "booking",
  info: "info",
  custom: "custom",
  eval: "eval",
} as const;
